import { HeaderAction, HeaderExternalLinkAction, HeaderLinkAction } from './HeaderAction';
import { HeaderActionGroup, HeaderActionGroupMenu } from './HeaderActionGroup';
import { HeaderActions } from './HeaderActions';
import { HeaderContent } from './HeaderContent';
import { HeaderRoot } from './HeaderRoot';
import { HeaderTabs } from './HeaderTabs';

export const Header = {
  Root: HeaderRoot,
  Content: HeaderContent,
  Actions: HeaderActions,
  ActionGroup: HeaderActionGroup,
  ActionGroupMenu: HeaderActionGroupMenu,
  Action: HeaderAction,
  LinkAction: HeaderLinkAction,
  ExternalLinkAction: HeaderExternalLinkAction,
  Tabs: HeaderTabs,
};
